<template>
  <div class="columns is-gapless is-border-bottom is-relative is-zindex-2">
    <div class="column is-narrow">
      <a
        class="page-header-btn is-small is-square has-cursor-grab is-border-right"
        style="cursor: move;">
        <span class="icon"><i class="fas fa-grip-lines"></i></span>
      </a>
    </div>

    <div
      v-if="step.is_valid"
      class="column is-narrow is-self-centered is-padding-left-small is-margin-right-xsmall">
      <div class="dot is-medium has-background-success has-text-white">
        <i class="fal fa-check is-size-6"></i>
      </div>
    </div>

    <div class="column is-expanded is-self-centered is-vcentered">
      <v-input
        classes-input="is-borderless is-shadowless"
        :name="step.step_uuid + 'name'"
        @input="step.name = $event; updateSelected()"
        :model="step.name"
        v-validate="'required|min:2'"
        :errors-bag="errors"
        data-vv-value-path="val"
        :read-only="step.is_valid"
        data-vv-as="Nom">
      </v-input>
    </div>
    <div class="column is-narrow has-text-centered is-border-left is-padding-left-small is-padding-right-small is-flex">
      <div class="is-self-centered">
        <span class="is-uppercase is-self-centered">Taux</span>
      </div>
    </div>
    <div
      class="column is-narrow is-border-left is-flex"
      :class="[step.is_valid ? 'is-w46p' : 'is-w90p']">
      <v-input
        class="is-self-centered"
        :classes-input="`is-shadowless is-minH49p ${tauxErrorClass}`"
        :name="step.step_uuid + 'progress'"
        @input="step.progress = $event; updateSelected()"
        :model="step.progress"
        :has-incrementations="true"
        :errors-bag="errors"
        :read-only="step.is_valid"
        :min="0"
        :max="100"
        :step="1"
        v-validate="'required|decimal:2|min_value:0|max_value:100'"
        data-vv-value-path="val"
        data-vv-as="Taux">
      </v-input>
    </div>
    <div class="column is-narrow is-border-right">
      <a class="page-header-btn is-small is-static is-square is-min-width-0">
        <span class="icon"><i class="fas fa-percentage"></i></span>
      </a>
    </div>
    <div class="column is-narrow is-self-centered">
      <div class="is-padding-xsmall">
        <input
          :id="step.step_uuid + 'step_is_valid'"
          type="checkbox"
          :name="step.step_uuid + 'step_is_valid'"
          class="switch is-rounded is-success is-small"
          v-model="step.is_valid">
        <label :for="step.step_uuid + 'step_is_valid'">
          <span class="is-size-5">{{ step.is_valid ? 'Validée': 'Valider étape' }}</span>
        </label>
      </div>
    </div>
    <div
      class="column is-narrow is-w50p is-border-left"
      v-if="step.is_valid">
      <date-picker
        :model="step.work_status_date"
        @input="step.work_status_date = $event; updateSelected()"
        class=""
        :field-class="''"
        :input-class="'is-absolute'"
        :style-version="3"
        :is-required="false"></date-picker>
    </div>
    <div
      class="column is-narrow is-minW140p is-border-left"
      v-if="step.is_valid && documents && documents.length">
      <a
        class="page-header-btn is-small is-fullwidth"
        @click="openDocumentModal(step)">
        <span class="is-lowercase is-underline">{{ documents.length }} document(s) lié(s)</span>
      </a>
    </div>
    <div
      class="column is-narrow is-border-left"
      v-if="step.is_valid">
      <label
        class="page-header-btn is-square tooltip is-tooltip-top"
        data-tooltip="Lier un document">
        <input
          class="file-input"
          type="file"
          accept="image/*, .pdf"
          @change="processFile($event, step)"
          name="resume">
        <span
          v-if="!uploading"
          class="is-marginless icon is-size-4"><i class="fal fa-link"></i></span>
        <span
          v-else
          class="is-marginless icon has-text-grey"><i class="fas fa-spinner fa-spin"></i></span>
      </label>
    </div>
    <div class="column is-narrow is-border-left">
      <a
        class="page-header-btn is-small is-square is-grey is-inverted"
        :disabled="step.is_valid"
        @click="deletedStep()">
        <span class="icon"><i class="fal fa-trash-alt"></i></span>
      </a>
    </div>
  </div>
</template>
<script>
import { cloneDeep, differenceBy, differenceWith, isEmpty } from 'lodash'
import { mapState } from 'vuex'
import { Upload } from '@/mixins'

export default {
  name: 'ProgramAppelDeFondsItem',
  mixins: [Upload],
  props: {
    step: {
      type: Object,
      required: true
    },
    i: Number,
    // all adf documents
    adfDocuments: Array,
    // documents of step
    documents: Array
  },
  data () {
    return {
      validDocument: null,
      uploading: false
    }
  },
  computed: {
    ...mapState(['modal']),
    tauxErrorClass () {
      if (this.errors && this.errors.collect(this.step.step_uuid + 'progress')[0]) {
        return ''
      }
      return 'is-borderless'
    }
  },
  watch: {
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'DOCUMENTS_LIST' && results && params.id === this.step.step_uuid) {
          this.updateAdfDocument(results)
        }
      }
    }
  },
  methods: {
    async processFile (event) {
      let file = event.target.files[0]
      this.validDocument = await this.checkAutorizedFile(file)
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let files = new FormData()
      files.append('file[]', file, file.name)
      this.uploading = true
      let document = null
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: files })
        document = res.data[0]
        document.fus_id = document.id
        document.destination = [`step-${this.step.step_uuid}`]
        delete document.size
        delete document.uses
      } catch (e) {
        console.log(e)
      } finally {
        this.uploading = false
      }
      if (document) {
        this.$emit('updateAdfDocument', [...this.adfDocuments, document])
      }
    },
    updateSelected () {
      this.$emit('updateSelected')
    },
    openDocumentModal () {
      let params = {
        source: cloneDeep(this.documents),
        title: `Fichiers liés à l'appel de fond ${this.step.name}`,
        id: this.step.step_uuid,
        warningType: 'adf'
      }
      this.$store.commit('setModal', { mode: 'DOCUMENTS_LIST', params })
    },
    updateAdfDocument (results) {
      let docs = [ ...this.adfDocuments ]
      let deletedDiffs = differenceBy(this.documents, results, 'id')
      if (deletedDiffs && deletedDiffs.length) {
        deletedDiffs.forEach(diff => {
          let idx = docs.findIndex(x => x.id === diff.id)
          if (idx >= 0) {
            docs.splice(idx, 1)
          }
        })
      }
      let updatedDiffs = differenceWith(results, this.documents, isEmpty)
      if (updatedDiffs && updatedDiffs.length) {
        updatedDiffs.forEach(diff => {
          let idx = docs.findIndex(x => x.id === diff.id)
          if (idx >= 0) {
            docs.splice(idx, 1, diff)
          }
        })
      }
      this.$emit('updateAdfDocument', docs)
    },
    async deletedStep () {
      if (this.step.is_valid) return
      let value = await this.$swal({
        title: 'Suppression de l\'appel de fond',
        text: 'L\'appel de fond ne sera plus accessible. Les ADV seront actualisés avec ce paramètre.',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && !value.dismiss) {
        this.$emit('deleteStep')
      }
    }
  }
}
</script>
